import { render, staticRenderFns } from "./ChartCorrelationItems.vue?vue&type=template&id=c8524124&"
import script from "./ChartCorrelationItems.vue?vue&type=script&lang=js&"
export * from "./ChartCorrelationItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports